import React, { Component } from 'react';


const title = "You\’re 3 Steps Away From Your First Meet";
const subtitle = "How It Works";

let WorkListContent = [
    {
        imgUrl: 'assets/images/work/01.png',
        imgAlt: 'work thumb',
        step: 'step',
        stepCount: '01',
        title: 'Create A Profile',
        desc: 'Provide accurate details to enable us to protect you well. The integrity of our platform depends on the ingenuity of our customers.',
    },
    {
        imgUrl: 'assets/images/work/02.png',
        imgAlt: 'work thumb',
        step: 'step',
        stepCount: '02',
        title: 'Find a Match',
        desc: 'Search through a catalog of members and easily find the perfect partner enabled by our state-of-the-art algorithm.',
    },
    {
        imgUrl: 'assets/images/work/03.png',
        imgAlt: 'work thumb',
        step: 'step',
        stepCount: '03',
        title: 'Connect with your Partner',
        desc: 'Meet your partner through our help and plan a future together.',
    },
]

class WorkSection extends Component {
    state = {  } 
    render() { 
        return (
            <section className="work-section padding-tb">
                <div className="container">
                    <div className="section-header">
                        <h4 className="theme-color">{subtitle}</h4>
                        <h2>{title}</h2>
                    </div>
                    <div className="section-wrapper">
                        <div className="row justify-content-center g-5">
                            {WorkListContent.map((val, i) => (
                                <div className="col-lg-4 col-sm-6 col-12 px-4" key={i}>
                                    <div className="lab-item work-item">
                                        <div className="lab-inner text-center">
                                            <div className="lab-thumb">
                                                <div className="thumb-inner">
                                                    <img 
                                                        src={`${val.imgUrl}`} 
                                                        alt={`${val.imgAlt}`} 
                                                    />
                                                    <div className="step">
                                                        <span>{val.step}</span>
                                                        <p>{val.stepCount}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="lab-content">
                                                <h4>{val.title}</h4>
                                                <p>{val.desc}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
 
export default WorkSection;